import dayjs from 'src/utils/dayjs';
import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getAllCFDIs = serviceBase({
  request: options =>
    axiosClient.get('/invoice', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
});

export const cancelCfdi = serviceBase({
  request: values => {
    return axiosClient.post(`/invoice/${values.id}/cancel`, {
      motive: values.motive,
      relatedInvoiceData: values
    });
  }
});

export const downloadExportedCFDIIssued = serviceBase({
  request: options =>
    axiosClient.get('/invoice/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const date = dayjs(
        new Date(res.config.params.year, res.config.params.month - 1, 1)
      ).format('MMMM-YYYY');
      const filename = `CFDI Emitidos - ${date}.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const loadCFDIsIncome = serviceBase({
  request: options =>
    axiosClient.get('/invoice/tax-accounting-income-resume', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
});

export const downloadExportedCFDIIncome = serviceBase({
  request: options =>
    axiosClient.get('/invoice/tax-accounting-income-resume/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `CFDI Ingresos - ${dayjs(
        res.config.params.afterDate
      ).format('MMMM-YYYY')}.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const loadCFDIsExpense = serviceBase({
  request: options =>
    axiosClient.get('/invoice/tax-accounting-expense-resume', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
});

export const loadCFDIsPayment = serviceBase({
  request: options =>
    axiosClient.get('/invoice/tax-accounting-payment-resume', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
});

export const downloadExportedCFDIExpense = serviceBase({
  request: options =>
    axiosClient.get('/invoice/tax-accounting-expense-resume/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `CFDI Egreso - ${dayjs(
        res.config.params.afterDate
      ).format('MMMM-YYYY')}.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const downloadExportedCFDIPayment = serviceBase({
  request: options =>
    axiosClient.get('/invoice/tax-accounting-payment-resume/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `CFDI Pagos - ${dayjs(
        res.config.params.afterDate
      ).format('MMMM-YYYY')}.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const sendInvoiceEmailToClient = serviceBase({
  request: ({ id, emailList }) =>
    axiosClient.post(`/invoice/send-invoice-to-client/${id}`, {
      emailList
    })
});

export const sendInvoiceToClientWhatsapp = serviceBase({
  request: ({ id, phones }) =>
    axiosClient.post(`/invoice/send/whatsapp/${id}`, {
      phones
    })
});

export const getWithholdings = serviceBase({
  request: options =>
    axiosClient.get('/invoice/tax-accounting-withholding-resume', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
});

export const exportWithholdings = serviceBase({
  request: options =>
    axiosClient.get('/invoice/tax-accounting-withholding-resume/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `Retenciones - ${dayjs(
        res.config.params.afterDate
      ).format('MMMM-YYYY')}.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const getCFDIReceived = serviceBase({
  request: options =>
    axiosClient.get('/invoice', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
});

export const downloadExportedCFDIReceived = serviceBase({
  request: options =>
    axiosClient.get('/invoice/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `CFDI Recibidos.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const downloadCFDIsReceivedInZip = serviceBase({
  request: options =>
    axiosClient.get('/invoices/received/export_zip', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `CFDI Emitido - ${dayjs(
        res.config.params.afterDate
      ).format('MMMM-YYYY')}.zip`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const downloadInvoices = serviceBase({
  request: options =>
    axiosClient.get('/invoice/export/zip', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `Facturas - ${dayjs(
        new Date(res.config.params.year, res.config.params.month - 1, 1)
      ).format('MMMM-YYYY')}.zip`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const getPendingPaymentIncomeCDFIs = serviceBase({
  request: contractId =>
    axiosClient.get(`/invoice/contract/${contractId}/pending-payment`)
});

export const syncInvoices = serviceBase({
  request: ({ year, month }) =>
    axiosClient.post('/invoice/sync-invoices', { year, month }, { timeout: 120000 })
});

export const getPendingPaymentIncomeCDFIsForClient = serviceBase({
  request: clientId =>
    axiosClient.get(`/invoice/client/${clientId}/pending-payment`)
});
